export default __webpack_public_path__ + "static/media/673.4295b295.png";